/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunHead3.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation6.play();
    actions.Animation6.repetitions = 1;
    actions.Animation6.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="head3" position={[0.4, 0, 0]} rotation={[0, 0, 0.7]}>
          <mesh geometry={nodes.圓柱體010.geometry} material={materials['材質.006']} />
          <mesh geometry={nodes.圓柱體010_1.geometry} material={materials['材質.005']} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunHead3.glb')
